import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { AppHeader } from "@/components/layout/AppHeader";
import { PageLoader } from "@/components/layout/PageLoader";
import { SiteFooter } from "@/components/layout/SiteFooter";
import {
  BusinessPlanDocumentView,
  printBusinessPlan,
} from "@/components/business-plan/BusinessPlanDocumentView";
import { useAuth } from "@/hooks/useAuth.hook";
import { useStartupContext } from "@/hooks/useStartupContext";
import { investorFounderAPI } from "@/services/api/investor.service";
import { Button } from "@/components/atoms";

export function BusinessPlanPage() {
  const navigate = useNavigate();
  const { userProfile, signOut } = useAuth();
  const { currentStartup } = useStartupContext();
  const startupId = currentStartup?.id ?? "";

  const { data: plan, isLoading } = useQuery({
    queryKey: ["businessPlan", startupId],
    queryFn: () => investorFounderAPI.getBusinessPlan(startupId),
    enabled: Boolean(startupId),
  });

  if (!startupId) {
    return <PageLoader />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-page text-white">
      <div className="bp-no-print">
        <AppHeader
          displayName={userProfile?.displayName}
          onSettingsClick={() => navigate("/settings/investor")}
          onSignOut={signOut}
        />
        <div className="flex w-full items-center justify-between gap-3 px-4 py-4 sm:px-6 lg:px-8">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => navigate("/settings/investor")}
          >
            ← Back to investor settings
          </Button>
        </div>
      </div>

      {isLoading ? (
        <PageLoader />
      ) : !plan ? (
        <div className="mx-auto w-full max-w-3xl px-4 py-16 text-center lg:px-8">
          <h1 className="text-2xl font-bold text-white">No business plan yet</h1>
          <p className="mt-2 text-white/65">
            Generate a plan from Settings → Investor portal.
          </p>
          <Button
            type="button"
            variant="primary"
            size="md"
            className="mt-6"
            onClick={() => navigate("/settings/investor")}
          >
            Go to investor settings
          </Button>
        </div>
      ) : (
        <BusinessPlanDocumentView
          plan={plan}
          showPrintButton
          onPrint={printBusinessPlan}
        />
      )}

      <div className="bp-no-print">
        <SiteFooter variant="compact" className="mt-8" />
      </div>
    </div>
  );
}
